import type { ScanIconName } from "../../enums/scan";
import { SCAN_ICON_NAME } from "../../enums/scan";
export type IconName = ScanIconName;

export function ScanIcon(props: { name: IconName }) {
  return (
    <svg
      class="signal-side-icon"
      viewBox="0 0 24 24"
      aria-hidden="true"
      fill="none"
    >
      <IconPath name={props.name} />
    </svg>
  );
}

function IconPath(props: { name: IconName }) {
  switch (props.name) {
    case SCAN_ICON_NAME.SUMMARY:
      return (
        <path
          d="M5 6.5h6v5H5zM13 6.5h6v3.2h-6zM13 12.7h6v4.8h-6zM5 14.5h6v3H5z"
          stroke="currentColor"
          stroke-linejoin="round"
          stroke-width="1.8"
        />
      );
    case SCAN_ICON_NAME.PAGES:
      return (
        <path
          d="M7 4h8l3 3v13H7zM15 4v4h4"
          stroke="currentColor"
          stroke-linejoin="round"
          stroke-width="1.8"
        />
      );
    case SCAN_ICON_NAME.ISSUES:
      return (
        <path
          d="M12 4 21 19H3zM12 9v4M12 16h.01"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.8"
        />
      );
    case SCAN_ICON_NAME.RUNS:
      return (
        <path
          d="M12 7v5l3 2M12 3a9 9 0 1 1-9 9"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.8"
        />
      );
    case SCAN_ICON_NAME.SIGNALS:
      return (
        <path
          d="M4 17V9M9 17V5M14 17v-6M19 17V8"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-width="1.8"
        />
      );
    case SCAN_ICON_NAME.JOURNEYS:
      return (
        <path
          d="M4 13h4l2-6 4 10 2-6h4"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.8"
        />
      );
    case SCAN_ICON_NAME.AI:
      return (
        <path
          d="m12 3 1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8zM19 16l.8 2.2L22 19l-2.2.8L19 22l-.8-2.2L16 19l2.2-.8z"
          stroke="currentColor"
          stroke-linejoin="round"
          stroke-width="1.6"
        />
      );
    case SCAN_ICON_NAME.BRAND:
      return (
        <path
          d="M6 4h12v16H6zM9 8h6M9 12h6M9 16h4"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.8"
        />
      );
    default:
      return (
        <path
          d="M7 7h10v10H7z"
          stroke="currentColor"
          stroke-linejoin="round"
          stroke-width="1.8"
        />
      );
  }
}
